export default __webpack_public_path__ + "static/l5-case3-35d989b962ccc721bbdf498e6d685d78.jpg";